import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { getSession } from "@/services/auth-service"
import type { WooCommerceProduct } from "~/services/woo-commerce-service"
import { DescriptionTab } from "./description"
import { ProductReviewsTabClient } from "./reviews/client"
import { SpecificationsTab } from "./specifications"

interface ProductDetailsTabsProps {
  initialTab?: "description" | "reviews" | "specification"
  product: WooCommerceProduct
  writeReview?: boolean
}

export const ProductDetailsTabs = async ({
  initialTab = "description",
  product,
  writeReview = false,
}: ProductDetailsTabsProps) => {
  const session = await getSession()
  const sessionCookie = session?.wordpressSessionCookie

  return (
    <Tabs defaultValue={initialTab}>
      <TabsList className='justify-center'>
        <TabsTrigger value='description'>Descrição</TabsTrigger>
        <TabsTrigger value='specification'>Especificação</TabsTrigger>
        <TabsTrigger value='reviews'>
          Avaliações ({product.rating_count})
        </TabsTrigger>
      </TabsList>

      <TabsContent value='description'>
        <DescriptionTab description={product.description} />
      </TabsContent>

      <TabsContent value='specification'>
        <SpecificationsTab attributes={product.attributes} />
      </TabsContent>

      <TabsContent value='reviews'>
        <ProductReviewsTabClient
          productId={product.id}
          sessionCookie={sessionCookie}
          writeReview={writeReview}
        />
      </TabsContent>
    </Tabs>
  )
}
